import { defineMessages } from 'react-intl';

export default defineMessages({
    searchContact:{
        id:'gateway.package-info.Search Contact',
        defaultMessage:'Search Contact'
    }
});
